import React from 'react';
import Table from 'components/Table';
import SegmentTag from 'components/SegmentTag';

const ResultStats = ({ results, loading, segments = [] }) => {
  const renderSegment = (segmentId) => <SegmentTag segment={segments.find(s => s.id === segmentId)} showDateRange />;

  const statsColumns = [
    {
      title: 'Segment',
      dataIndex: 'segmentId',
      render: renderSegment,
    },
    {
      title: 'Rows',
      dataIndex: ['statistics', 'rows'],
      type: 'number',
    },
    {
      title: 'Totals',
      dataIndex: ['statistics', 'rowsBeforeLimitAtLeast'],
      type: 'number',
    },
    {
      title: 'Elapsed',
      dataIndex: ['statistics', 'elapsed'],
      type: 'seconds',
    },
    {
      title: 'Rows read',
      dataIndex: ['statistics', 'rowsRead'],
      type: 'number',
    },
    {
      title: 'Bytes read',
      dataIndex: ['statistics', 'bytesRead'],
      type: 'bytes',
    },
    {
      title: 'Bytes transferred',
      dataIndex: ['statistics', 'transferred'],
      type: 'bytes',
    },
  ];

  return (
    <Table
      rowKey="segmentId"
      loading={loading}
      columns={statsColumns}
      dataSource={results}
      pagination={false}
    />
  );
};

export default ResultStats;
